import { HttpClient, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { API_BASE_URL, API_VERSION_PREFIX } from '../tokens/api-base-url.token';

type QueryValue = string | number | boolean | readonly string[] | undefined | null;

/**
 * Shared plumbing for the Feedback API services: an `HttpClient`, the
 * configured base URL, and helpers for composing endpoint URLs and query
 * parameters. Concrete services extend this.
 */
export abstract class FeedbackApiBase {
  protected readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  /** Builds a fully-qualified URL for an `/api/v1` endpoint path. */
  protected url(path: string): string {
    const endpointPath = path.replace(/^\/+/, '');
    return `${this.baseUrl}/${API_VERSION_PREFIX}/${endpointPath}`;
  }

  /**
   * Builds `HttpParams`, omitting `undefined`/`null` entries and empty lists. A list is
   * sent comma-separated (`status=a,b`), the form the API accepts for several values.
   */
  protected buildParams(query: Record<string, QueryValue>): HttpParams {
    let params = new HttpParams();
    for (const [paramName, paramValue] of Object.entries(query)) {
      if (paramValue === undefined || paramValue === null) {
        continue;
      }
      if (Array.isArray(paramValue)) {
        if (paramValue.length) {
          params = params.set(paramName, paramValue.join(','));
        }
        continue;
      }
      params = params.set(paramName, String(paramValue));
    }
    return params;
  }
}
